import React, {Component, Fragment} from 'react';
import {connect} from "react-redux";
import PropTypes from 'prop-types';
import windowSize from "../libs/reactWindowSize";
import { withScenePosition, getFontSize } from "../scenePosition";

class Timer extends Component {

  constructor(props){
    super(props);

    this.clearInterval = this.clearInterval.bind(this);
    this.tick = this.tick.bind(this);
    this.calcHours = this.calcHours.bind(this);
    this.calcMinutes = this.calcMinutes.bind(this);
    this.calcSeconds = this.calcSeconds.bind(this);

    this.state = {
      currentTime: this.props.startTime,
      currentHours: this.calcHours(this.props.startTime),
      currentMinutes: this.calcMinutes(this.props.startTime),
      currentSeconds: this.calcSeconds(this.props.startTime)
    };
  }

  static getDerivedStateFromProps(props, state){
    let { windowWidth } = props;

    let fontSize = getFontSize(windowWidth) + 'px';

    return {
      ...state,
      fontSize: fontSize
    }
  }

  componentDidMount() {
    this.interval = setInterval(this.tick, 1000);
  }

  componentWillUnmount() {
    this.clearInterval();
  }

  zeroPad(value, length = 2) {
    if (length === 0) return value;
    const strValue = String(value);
    return strValue.length >= length ? strValue : ('0'.repeat(length) + strValue).slice(length * -1);
  };

  calcHours(time) {
    return Math.floor(time / 3600);
  }

  calcMinutes(time) {
    if (this.props.showHour) {
      return Math.floor((time % 3600) / 60);
    }
    else {
      return Math.floor(time / 60);
    }
  }

  calcSeconds(time) {
    return this.zeroPad(Math.ceil((time % 3600) % 60));
  }

  clearInterval() {
    clearInterval(this.interval);
    delete this.interval;
  }

  tick() {
    this.setState({
      currentTime: this.state.currentTime+1,
      currentHours: this.calcHours(this.state.currentTime+1),
      currentMinutes: this.calcMinutes(this.state.currentTime+1),
      currentSeconds: this.calcSeconds(this.state.currentTime+1)
    });
  };

  renderTime() {
    if (this.props.stringFormat === "letter") {
      if (!!this.props.showHour) {
        return (<Fragment>{this.state.currentHours > 0 ? this.state.currentHours+"h " : ""}{this.state.currentMinutes > 0 ? this.state.currentMinutes+"m " : ""}{this.state.currentSeconds}s</Fragment>);
      }
      else {
        return (<Fragment>{this.state.currentMinutes > 0 ? this.state.currentMinutes+"m " : ""}{this.state.currentSeconds}s</Fragment>);
      }
    }
    else {
      if (!!this.props.showHour) {
        return (<Fragment>{this.state.currentHours}:{this.state.currentMinutes}:{this.state.currentSeconds}</Fragment>);
      }
      else {
        return (<Fragment>{this.state.currentMinutes}:{this.state.currentSeconds}</Fragment>);
      }
    }
  }

  render() {
    const { fontSize } = this.state;
    const  { top, left, step } = this.props;

    let isHidden = false;
    if (
      (!!this.props.excludeId && this.props.excludeId === step.timerId) ||
      (!!this.props.includeId && this.props.includeId !== step.timerId)
    ) {
      isHidden = true;
    }

    const timerClasses = [
      "timer-container",
      this.props.color,
      this.props.stringFormat === "letter" ? "letter-format" : null,
      this.props.alignment === "right" ? "align-right" : null,
      isHidden ? "hidden" : null
    ];

    const timerClass = timerClasses.join(" ");

    return (
      <div className={timerClass} style={{left: left, top: top, fontSize: fontSize}}>
        <span style={{fontSize: this.props.fontSize + "em"}}>{this.renderTime()}</span>
      </div>
    );
  }

}

Timer.propTypes = {
  startTime: PropTypes.number, // starting time (in seconds)
  endTime: PropTypes.number, // point at which timer resets to start time
  showHour: PropTypes.bool, // whether or not the hour should be shown
  fontSize: PropTypes.number, // font size for timer (in `em` in relation to 16px base font size)
  color: PropTypes.string, // class applied for color: OPTIONS: "green", "blue"
  stringFormat: PropTypes.string, // layout style for timer. ( "clock" : 9:9:9 , "letter" : 9h 9m 9s )
  alignment: PropTypes.string, // class applied for alignment: OPTIONS: "left", "right"
  excludeId: PropTypes.string, // timerId on step, if matches, hides this timer
  includeId: PropTypes.string // timerId on step, if matches, shows this timer (otherwise, hides)
};

Timer.defaultProps = {
  startTime: 0,
  endTime: 599, // 9:59
  showHour: false,
  fontSize: .7,
  color: "green",
  stringFormat: "clock",
  alignment: "left"
}

function mapStateToProps(state) {
  return {
    scene: state.scene,
    step: state.step,
    menuState: state.menu
  }
}

export default windowSize(connect(mapStateToProps)(withScenePosition(Timer)));



// WEBPACK FOOTER //
// ./src/components/Timer.jsx